import { Typography } from '@vartanainc/design-system';
import TruncatedText from '../TruncatedText/TruncatedText';

interface ContactTooltipElementProps {
  email?: string;
  phone?: string;
}

export function ContactTooltipElement({
  email,
  phone,
}: ContactTooltipElementProps): JSX.Element {
  return (
    <div
      className={`flex items-center ${
        email ? 'divide-x-[1.5px] divide-solid divide-[#E2E2E2] gap-2 pt-1 pb-2' : ''
      }`}
    >
      <div className=" max-w-[190px]">
        <TruncatedText
          variant="paragraph12"
          color="color-gray-120"
          bold={false}
          text={email || ''}
          maxChar={phone ? 23 : 50}
          showTooltip
          multilineTooltip={false}
          className={null}
        />
      </div>
      <Typography
        variant="paragraph12"
        color="color-gray-120"
        className={`${email ? 'pl-2' : ''}`}
      >
        {phone}
      </Typography>
    </div>
  );
}
